module.exports = {
    messages: {
        de:
        {
            search: {
                allResults: "Alle {resultcount} Ergebnisse laden",
                for: "nach",
                fulltextsearch: "Volltextsuche",
                furtherResults: "Nächste 10 Ergebnisse laden",
                hit: "Treffer | Treffer | Treffer",
                hits: "Insgesamt {n} {hit}",
                noResults: "Keine Treffer",
                search: "Suchen",
                searchResults: "Suchergebnisse"
            }
        },
        en:
        {
            search: {
                allResults: "Retrieve all {resultcount} results",
                for: "for",
                fulltextsearch: "Full-text search",
                furtherResults: "Retrieve next 10 results",
                hit: "hits | hit | hits",
                hits: "{n} {hit} overall",
                noResults: "No results",
                search: "Search",
                searchResults: "Search results"
            }
        },
        fr:
        {
            search: {
                allResults: "Charger tous les {resultcount} résultats",
                for: "pour",
                fulltextsearch: "Recherche intégrale",
                furtherResults: "Résultats suivants",
                hit: "résultats | résultat | résultats",
                hits: "{n} {hit} en tout",
                noResults: "Aucun résultat",
                search: "Chercher",
                searchResults: "Résultats de la recherche"
            }
        }
    }
}
